module.exports = __webpack_public_path__ + "img/MEDIA077.9feed884.jpg";